export var PurchaseMethod = {
    Flixx: 1,
    TokenGating: 2,
};
